export default {"src":"/_next/static/media/mana0.8b8536af.svg","height":600,"width":600,"blurWidth":0,"blurHeight":0};